import { useEffect, useState } from "react";

/**
 * Hook to determine scroll-based transparency state.
 *
 * @param thresholdRatio - portion of the viewport height (e.g. 0.8 = 80% of viewport height)
 * @returns {boolean} whether the user has scrolled past the threshold
 */
export function useScrollTransparency(thresholdRatio = 0.6): boolean {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const threshold = window.innerHeight * thresholdRatio;

    const handleScroll = () => {
      setScrolled(window.scrollY > threshold);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [thresholdRatio]);

  return scrolled;
}
